import React, {useEffect, useState} from 'react';
import Timeline from "../../../components/Timeline/Timeline";
import subscriptionService from "../../../services/subscriptionService";
import HistoryIcon from "@material-ui/icons/History";
import {AssistantPhoto, Edit, Assessment} from "@material-ui/icons";
import AssignNewPlan from "./AssignNewPlan";
import makeStyles from "@material-ui/core/styles/makeStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import stylesSweet from "../../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import DCatHistoryBody from "../DCatHistoryBody";

const config = {
    'badgeColor': {
        0: 'info',
        1: 'success',
        'new': 'primary'//'danger' // new
    },
    'badgeIcon': {
        0: HistoryIcon,
        1: AssistantPhoto,
        'new': Assessment
    }
}
const useStyles = makeStyles({
    ...styles,
    ...stylesSweet,
    datePickerInput: {
        "textAlign": "center",
        "width": "91px",
        "color": "#fff",
        "fontWeight": "bold",
        "borderRadius": "13px",
        "borderColor": "#9c27b0",
        "borderStyle": "none",
        "backgroundColor": "#9c27b0",
        "padding": "3px 0px 3px 0px",
        "cursor": "pointer"
    },
    floatLeft: {float: "left"},
    floatRight: {float: "right"}
});

export default function UserDCatPlan(props) {
    const classes = useStyles();
    const {selected} = props;
    const [subscribedItems, setSubscribedItems] = useState([]);
    const [PlanList, setPlanList] = useState([]);
    const [endDate, setEndDate] = useState()
    const [alert, setAlert] = useState(null);
    useEffect(() => {
        loadPlans();
    }, []);
    useEffect(() => {
        setEndDate("");
        loadHistory();
    }, [selected])

    const loadHistory = async () => {
        const response = await subscriptionService.getHistory(selected.Username, 'one_time=1&type=DCAT');
        setSubscribedItems(response.data.data.result);
    }
    const loadPlans = async () => {
        const response = await subscriptionService.getPlans("&one_time=1&type=DCAT");
        setPlanList(response.data.data.result.data);
    }

    const update = async (param) => {
        const r = await subscriptionService.put(selected.Username, param)
        if (r.status === 200) {
            successAlert();
        }
    }

    const successAlert = () => {
        setAlert(
            <SweetAlert
                success
                style={{display: "block", marginTop: "-100px"}}
                title="Success"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnCssClass={classes.button + " " + classes.success}
            >
                Plan updated successfully!
            </SweetAlert>
        );
    };
    const loadTineStories = items => {
        let newItems = [
            {
                inverted: true,
                badgeColor: config.badgeColor['new'],
                badgeIcon: config.badgeIcon['new'],
                title: "Assign a DiagnoCat Plan",
                titleColor: config.badgeColor['new'],
                body: (''),
                footer: (
                    <AssignNewPlan PlanList={PlanList} loadHistory={loadHistory} user={selected} type={"onetime"}/>
                )
            }
        ];


        items.forEach(si => {

            newItems.push({
                inverted: true,
                badgeColor: config.badgeColor[si.Status],
                badgeIcon: config.badgeIcon[si.Status],
                title: si.PlanName,
                titleColor: config.badgeColor[si.Status],
                body: (<div>
                    <hr/>
                    <DCatHistoryBody si={si} update={update}/>
                </div>),
            })
        });
        return newItems;
    }

    return <span>
        {alert}
        <Timeline simple stories={loadTineStories(subscribedItems)}/>
    </span>

}